import { createFileRoute } from "@tanstack/react-router";

import { DepartmentPage, departmentHead } from "../components/prenoms/department-pages";
import { orNotFound } from "../components/prenoms/load";
import { namesApi } from "../lib/api";
import { seo } from "../lib/head";

export const Route = createFileRoute("/prenoms/departement/$department")({
  staticData: { ssr: true },
  loader: ({ context, params }) =>
    orNotFound(() =>
      context.queryClient.query({
        queryKey: ["prenoms-department", params.department],
        queryFn: () => namesApi.department(params.department),
        staleTime: "static",
      }),
    ),
  head: ({ loaderData }) => (loaderData ? seo(departmentHead(loaderData)) : {}),
  component: Page,
});
function Page() {
  return <DepartmentPage data={Route.useLoaderData()} />;
}
